var withVideoParams = require('./withVideoParams');

module.exports = withVideoParams;
